
import { defineComponent } from 'vue';
import { IContact } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/contacts';
import FormSearch from './components/contacts/FormSearch.vue';
import FormSubmit from './components/contacts/FormSubmit.vue';

interface IFormSearch {
  currentPage: number;
  offset: number;
  limit: number;
  dateFrom: string;
  dateTo: string;
  keyword: string;
}

interface IState {
  items: IContact[];
  count: number;
  formSearch: IFormSearch;
  isContact: boolean;
  contact: IContact;
}

export default defineComponent({
  components: { FormSearch, FormSubmit },
  data() {
    return {
      items: [],
      count: 0,
      formSearch: {
        currentPage: 1,
        offset: 0,
        limit: 30,
        dateFrom: '',
        dateTo: '',
        keyword: '',
      },
      isContact: false,
      contact: {} as IContact,
    } as IState;
  },
  methods: {
    apiGet() {
      api.getContacts(
        {
          offset: this.formSearch.offset,
          limit: this.formSearch.limit,
          keyword: '',
          dateFrom: '',
          dateTo: '',
        },
        (res) => {
          if (!res) return;

          this.items = res.items;
          this.count = res.count;
        },
      );
    },

    apiDelete(contactId: number) {
      api.delete(
        {
          contactId,
        },
        (res) => {
          if (!res) return;

          this.apiGet();
        },
      );
    },

    apiReply(memo: string) {
      api.reply(
        {
          contactId: this.contact.id,
          memo,
        },
        (res) => {
          if (!res) return;

          utils.success('回复成功！');
          this.isContact = false;
          this.apiGet();
        },
      );
    },

    btnDeleteClick(contact: IContact) {
      utils.alertDelete(
        {
          title: '删除咨询',
          text: '此操作将会删除选中的咨询信息，确定吗？',
        },
        () => {
          this.apiDelete(contact.id);
        },
      );
    },

    btnSearchClick(form: { dateFrom: string; dateTo: string; keyword: string }) {
      this.formSearch = {
        ...form,
        currentPage: 1,
        offset: 0,
        limit: 30,
      };

      utils.loading(true);
      api.getContacts(this.formSearch, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
    },

    handleCurrentChange(val: number) {
      this.formSearch.currentPage = val;
      this.formSearch.offset = this.formSearch.limit * (val - 1);

      utils.loading(true);
      api.getContacts(this.formSearch, (res) => {
        if (!res) return;

        this.items = res.items;
        this.count = res.count;
      });
      utils.scrollTop();
    },

    btnReplyClick(contact: IContact) {
      this.isContact = true;
      this.contact = contact;
    },
  },
  mounted() {
    this.apiGet();
  },
});
